import React, { useEffect, useState } from 'react'
import FlatList from 'flatlist-react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Loading } from '../../components/Loading';
import { baseUrlback } from '../../urlApi';


export const DocPorFirmar = () => {

  const data = useSelector(state => state.login.data)

  const rut = data.personaId
  
  // console.log('rut',rut)

  const empresaId = localStorage.getItem('empresaId')
  const conid = localStorage.getItem('conid')

  // console.log('empresaId',empresaId)
  

  let navigate = useNavigate();

 
  const [loading, setLoading] = useState(true)

       
  const [objPdf, setobjPdf] = useState([])




        const consultarDatos = async () => {
          try {

              const response = await axios.get(`${baseUrlback}api/firma/sin-firmar/${rut}/${conid}`);
                      
              // console.log('QE TRAE',response.data)

              // Filtramos para que la data del rut coincida con el rut de la empresa y que ademas le toque firmar

              let responseFiltradaEmpresa = response.data.filter(item  => item.empid === empresaId && item.flujo !== 'contraparte'  )
                
              setobjPdf(responseFiltradaEmpresa)
              // console.log('responseFiltradaEmpresa',responseFiltradaEmpresa)

              
                  setLoading(false)


              } catch (error) {
                
              alert("Error de conexion","Intentalo otra vez", );
              setLoading(false)
                  console.log(error)
              }


      }

      useEffect(() => {

          consultarDatos()
      }, [])


      // console.log(objPdf)


  return (
    <>

     <div className='contenedorDocPorFirmar' >

     <div className='contenidoTodoTablaDocPorFirmar' > 
                  {/* header tabla */}
                  <div className='headerTablaDocPorFirmar' >

                    <p>Fecha solicitud</p>
                    <p>Tipo de documento</p>
                    <p>Accion</p>


                  </div>
                  

                  <div className='contenidoTablaDocPorFirmar' >

                    {

                    loading ? <div className='marginTopFirmas'><Loading/> </div>  :

                      
                    <FlatList list={objPdf} renderItem={(item,index) => 
                      <div key={index} className='divflat' >
                          <p>{item.fechaCreacion}</p>
                          <p>{item.tipo}</p>
                          <p className='firmar' onClick={ () => navigate(`/verpdf/${item.id}/${item.codper}`)}  > Ver - Firmar </p>

                       
                          


                      </div>
              
              
              
              
                    
                    }
                    
                    renderWhenEmpty={() =>
                      <div className='renderEmpty' >

                        
                          <p> No tienes documentos por firmar </p>
                        

                    

                      </div>
                    }
                    hasMoreItems
                    renderOnScroll
                    />

                    }

                      



                  </div>


                 



            </div>
        







     </div>





    </>
  )
}
